import { render, staticRenderFns } from "./personalContent.vue?vue&type=template&id=81f17564&scoped=true&"
import script from "./personalContent.vue?vue&type=script&lang=js&"
export * from "./personalContent.vue?vue&type=script&lang=js&"
import style0 from "./personalContent.vue?vue&type=style&index=0&id=81f17564&prod&lang=scss&scoped=true&"
import style1 from "./personalContent.vue?vue&type=style&index=1&id=81f17564&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f17564",
  null
  
)

export default component.exports